// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YAUBijiTC3WhjiJRzT1q {
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  height: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Header/styles.module.less"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AACF","sourcesContent":[".header {\n  border-bottom: 1px solid #eee;\n  display: flex;\n  align-items: center;\n  height: 60px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `YAUBijiTC3WhjiJRzT1q`
};
export default ___CSS_LOADER_EXPORT___;
